import store from '@/store/store'
import moment from 'moment';
import CryptoJS from 'crypto-js'

export default class Helpers {    
    static key = CryptoJS.enc.Base64.parse("Q3JpcHRvZ3JhZmlhcyBjb20gUmluamRhZWwgLyBBRVM=");
    static iv = CryptoJS.enc.Base64.parse("UAjx3d488hhEdBksU0mrvA==");

    constructor() {
    }

    static buscarPerfilPortalTela(tela){
        var listGrants = []
            if (typeof store.state.access.perfisPortal !== 'undefined') {
                for (let i = 0; i <= store.state.access.perfisPortal.length -1; i++) {
                    if (store.state.access.perfisPortal[i].nomeTela.toLowerCase().trim() == tela.toLowerCase().trim()) {
                        listGrants.push(store.state.access.perfisPortal[i].idPerfilPortal)
                    }
                }
            }
        return listGrants
    }

    static funcionalidadeAutorizada(plan) {
        let funcionalidadesPermitidas = store.state.access.perfisPortal.map(p => {
            if (p.idPerfilPortal === store.state.auth.idPerfilPortal) {
                if (p.idTela === plan.idTela) {
                    if (p.nomeFuncionalidade)
                        return p.nomeFuncionalidade.toLowerCase();
                }
            }
        }).filter(s => { return s != undefined });
        if (funcionalidadesPermitidas.includes(plan.funcionalidade.toLowerCase()))
            return true;
        return false;
    }

    static formatarData(data) {
        let is_date_time = arguments.length > 1 ? arguments[1] : false;
        let format_local = arguments.length > 2 ? arguments[2] : 'DD/MM/YYYY HH:mm:ss';

        if ((data) && (data != "0001-01-01T00:00:00")){
            var d = moment(data);
            if (!is_date_time)
                return d.format("DD/MM/YYYY");
            return d.format(format_local);   
        } else {
            return "";
        }   
    }

    static formatarMoeda(value) {
        let retValue = "";
        if (value !== undefined)
            retValue = value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        
        return retValue;
    }

    static limparDataNula(value) {        
        return value === "0001-01-01T00:00:00" ? "" : value;
    }

    static groupBy(xs, f) {
        return xs.reduce((r, v, i, a, k = f(v)) => ((r[k] || (r[k] = [])).push(v), r), {});
    }

    static formatString(value) {
        //return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        return value.toLocaleString('pt-BR');
    }

    static validarEmail(email) {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    static limparCaracteres(value) {
        if (value == null || value == undefined)
            return value
            
        if (Object.prototype.toString.call(value) == '[object Object]'){
            for (var key in value) {
                value[key] = this.limparCaracteres(value[key]);
            }
        }
        else if (Object.prototype.toString.call(value) == '[object String]'){
            value = value.replace(/\-\-+/gi, '-');
            //value = value.replace(/[^0-9a-zA-Z\._\-\@\#\s]/gi, ' ');
            value = value.replace(/\bDROP\b|\bINSERT\b|\bUPDATE\b|\bSELECT\b|\bDELETE\b|\bTRUNCATE\b|\bFROM\b|\bSCRIPT\b/gi, '');
            value = value.replace(/\s\s+/gi, ' ');
            return value
        }

        return value
    }

    static criptografarFront(value) {
        if (value == null || value == undefined)
            return value
            
        if (Object.prototype.toString.call(value) == '[object Object]'){
            for (var key in value) {
                value[key] = this.criptografarFront(value[key]);
            }
        }
        else if (Object.prototype.toString.call(value) == '[object String]'){            
            return CryptoJS.AES.encrypt(value, this.key, {iv: this.iv}).toString();
            //return encrypted.toString();
        }

        return value;
    }

    static aplicarValidacoes(value) {        
        value = this.limparCaracteres(value);
        value = JSON.stringify(value);
        value = this.criptografarFront(value);                
        
        return {Dados: value};
    }

    static parseDate(str) {
        var mdy = str.split('/');
        return new Date(mdy[2], mdy[0] - 1, mdy[1]);
    }

    static dateDiff(first, second) {
        return Math.round((second - first) / (1000 * 60 * 60 * 24));
    }    
}